import React, { memo, useMemo } from "react";

import { Checkbox } from "@mui/material";
import { dateToString } from "../../../../../../utils/dateAndTime";
import { VerifyCommandProductsListInterface } from "../../../../../../redux/interfaces/picking.interface";

import CustomButton from "../../../../../../components/CustomButton";
import withConfirmationModal from "../../hoc/withConfirmationModal";

function ProductCardComponent({
  product,
  isScannedProduct,
  commandCode,
  handleValidateProduct,
  handleShowConfirmationModal,
}: {
  product: VerifyCommandProductsListInterface;
  isScannedProduct: boolean;
  commandCode: string | number | null;
  handleValidateProduct: (
    product: VerifyCommandProductsListInterface,
    withProductScanAutoFocus?: boolean,
  ) => void;
  handleShowConfirmationModal?: ({
    product,
    commandCodeValue,
  }: {
    product?: VerifyCommandProductsListInterface;
    commandCodeValue?: string | number | null;
    type?: number;
  }) => void;
}) {
  const getTextStyle = () => {
    if (product.anulat) {
      return "text-danger";
    }
    if (product.cantitatePick > product.cantitate) {
      return "text-warning";
    }
    return "";
  };

  const isCheckboxVisible = useMemo(() => {
    if (product.anulat) {
      return product.cantitatePick === 0;
    }
    return product.cantitatePick === product.cantitate;
  }, [product]);

  return (
    <tr
      className={`fw-bolder text-hover-primary fs-7 ${getTextStyle()} ${
        isScannedProduct ? "text-info bg-gray-300" : ""
      }`}
      id={product.sn}>
      <td>
        {isCheckboxVisible && (
          <Checkbox
            tabIndex={1}
            checked={product?.isValidate || false}
            disableRipple
            style={{
              transform: "scale(1.6)",
            }}
            onClick={() => handleValidateProduct(product, true)}
            disabled={false}
            inputProps={{
              "aria-labelledby": `enhanced-table-checkbox-${product.idPozitiePicking}`,
            }}
          />
        )}
      </td>
      <td>{product.bnume}</td>
      <td>{`${product.cantitatePick}/${product.cantitate}`}</td>
      <td>{product.lot}</td>
      <td>{dateToString(product.data_exp)}</td>
      <td>{product.cNume}</td>
      <td>{product.cellScanned}</td>
      <td>
        <CustomButton
          tabIndex={-1}
          variant="contained"
          color="error"
          className="mt-0 mb-0 mx-1"
          withDropdown={{
            menuItems: [
              {
                value: 1,
                label: "Cantitate -",
                onClick: () =>
                  handleShowConfirmationModal &&
                  handleShowConfirmationModal({
                    product,
                    commandCodeValue: commandCode,
                    type: 1,
                  }),
              },
              {
                value: 2,
                label: "Cantitate +",
                onClick: () =>
                  handleShowConfirmationModal &&
                  handleShowConfirmationModal({
                    product,
                    commandCodeValue: commandCode,
                    type: 2,
                  }),
              },
              {
                value: 3,
                label: "Lot si BBD",
                onClick: () =>
                  handleShowConfirmationModal &&
                  handleShowConfirmationModal({
                    product,
                    commandCodeValue: commandCode,
                    type: 3,
                  }),
              },
            ],
          }}>
          Raporteaza eroare
        </CustomButton>
      </td>
    </tr>
  );
}

export default memo(withConfirmationModal(ProductCardComponent));
